export const serverurl = process.env.NODE_ENV === "production" ? "/" : "http://localhost:4000/";